import React, {useEffect, useState} from "react";
import { FormattedMessage } from "react-intl";
import Emitter from "../eventBus.js";

const MessageAlert = () => {
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState('');
  const [color, setColor] = useState('');

  useEffect(()=> {
    Emitter.on("showMessageAlert", function (params) {
      setShowAlert(true);
      setMessage(params.message);
      if(params.status==='success') {
        setColor('bg-emerald-500')
      }
      if(params.status==='warning') {
        setColor('bg-orange-500')
      }
      if(params.status==='error') {
        setColor('bg-red-500')
      }
      setTimeout(()=>{
        setShowAlert(false);
      }, 3000)
    });
    return () => {
      Emitter.removeListener('showMessageAlert', ()=>{});
    }
  },[]);


  return (
      <>
        {showAlert ? (
            <div className={"alert_modal z-10000 w-1/2 bottom-0 left-1/4 mt-7px transform-x-50 text-white px-6 py-4 border-0 rounded fixed mb-4 "+ color}>
          <span className="text-xl inline-block mr-5 align-middle">
            <i className="fas fa-bell" />
          </span>
              <span className="inline-block align-middle ml-2 ">
            <b className="capitalize">
              {message && <FormattedMessage textComponent="option" id={message} />}
            </b>
          </span>
              <button
                  className="float-right bg-transparent font-semibold leading-none outline-none focus:outline-none"
                  onClick={() => setShowAlert(false)}
              >
                <span>×</span>
              </button>
            </div>
        ) : null}
      </>
  );
};

export default MessageAlert